import React from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import { Clamp } from '../../utils/functions';
import Image from '../atoms/Image';

const Footer = ({ setCookiesOpened }) => {
  const {
    wpPage: { footer },
  } = useStaticQuery(graphql`
    query FooterQuery {
      wpPage(id: { eq: "cG9zdDoyOQ==" }) {
        footer {
          socialMedia {
            link {
              url
              title
            }
            icon {
              altText
              localFile {
                publicURL
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
          firstColumn {
            title {
              url
              title
            }
            links {
              link {
                url
                title
              }
            }
          }
          secondColumn {
            title {
              url
              title
            }
            links {
              link {
                url
                title
              }
            }
          }
          thirdColumn {
            title {
              url
              title
            }
            links {
              link {
                url
                title
              }
            }
          }
          fourthColumn {
            title {
              url
              title
            }
            links {
              link {
                url
                title
              }
            }
          }
          localizationPages{
            link {
              url
              title
            }
          }
          logoFooter {
            altText
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
  `);

  return (
    <Wrapper>
      <div className='max-width'>
        <div className='left-side'>
          <Link
            to='/'
            aria-label='Strona główna'
            className='logo'
          >
            <Image data={footer.logoFooter}/>
          </Link>
          <div className='socials'>
            <ul>
              {footer.socialMedia.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.link.url}
                    target='_blank'
                    rel='noreferrer noopener me'
                  >
                    {link.icon && (
                      <Image data={link.icon}/>
                    )}
                    <span dangerouslySetInnerHTML={{ __html: link.link.title }} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className='right-side'>
          <div className='links'>
            <Link
              to={footer.firstColumn.title.url}
              className='title'
            >
              {footer.firstColumn.title.title}
            </Link>
            <ul>
              {footer.firstColumn.links.map((link, i) => (
                <li key={i}>
                  <Link
                    to={link.link.url}
                    dangerouslySetInnerHTML={{ __html: link.link.title }}
                  />
                </li>
              ))}
            </ul>
          </div>
          <div className='links'>
            <Link
              to={footer.secondColumn.title.url}
              className='title'
            >
              {footer.secondColumn.title.title}
            </Link>
            <ul>
              {footer.secondColumn.links.map((link, i) => (
                <li key={i}>
                  <Link
                    to={link.link.url}
                    dangerouslySetInnerHTML={{ __html: link.link.title }}
                  />
                </li>
              ))}
            </ul>
          </div>
          <div className='links'>
            <Link
              to={footer.thirdColumn.title.url}
              className='title'
            >
              {footer.thirdColumn.title.title}
            </Link>
            <ul>
              {footer.thirdColumn.links.map((link, i) => (
                <li key={i}>
                  <Link
                    to={link.link.url}
                    dangerouslySetInnerHTML={{ __html: link.link.title }}
                  />
                </li>
              ))}
            </ul>
          </div>
          <div className='links'>
            <Link
              to={footer.fourthColumn.title.url}
              className='title'
            >
              {footer.fourthColumn.title.title}
            </Link>
            <ul>
              {footer.fourthColumn.links.map((link, i) => (
                <li key={i}>
                  <Link
                    to={link.link.url}
                    dangerouslySetInnerHTML={{ __html: link.link.title }}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className='localizations'>
        <p>Działamy na terenie całej Polski</p>
        <ul>
          {footer.localizationPages.map(el => (
            <li key={el.link.url}>
              <Link to={el.link.url}>
                {el.link.title}
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M2.66797 8H13.3346M13.3346 8L9.33464 4M13.3346 8L9.33464 12" stroke="#39843C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className='additional'>
        <a
          href='https://kryptonum.eu/pl'
          target='_blank'
          rel='noopener noreferrer'
          className='kryptonum'
        >
          Stworzone przez
          <svg
            width='113'
            height='24'
            viewBox='0 0 113 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M16.0713 11.9999C16.0711 12.8861 15.8003 13.753 15.2921 14.4946C14.7838 15.2361 14.06 15.8201 13.2094 16.1751V23.8382H9.39346V16.173C8.54289 15.8186 7.81909 15.235 7.31079 14.4938C6.80248 13.7525 6.53174 12.8858 6.53174 11.9999C6.53174 11.114 6.80248 10.2473 7.31079 9.50606C7.81909 8.76482 8.54289 8.18123 9.39346 7.82681V0.161621H13.2094V7.82469C14.0602 8.17943 14.7841 8.76338 15.2925 9.50499C15.8008 10.2466 16.0715 11.1137 16.0713 11.9999Z'
              fill='#546752'
            />
            <path
              d='M22.9212 0V5.46378L18.9359 9.26811L17.0287 7.44665L15.8004 8.61914C15.5208 8.28062 15.2003 7.97473 14.8457 7.70781L22.9212 0Z'
              fill='#546752'
            />
            <path
              d='M18.9354 14.7319L22.9208 18.5363V24L14.8462 16.2922C15.2005 16.0256 15.5208 15.72 15.8003 15.3818L17.0282 16.5534L18.9354 14.7319Z'
              fill='#546752'
            />
            <path
              d='M5.57913 11.9999C5.57675 13.2266 6.00945 14.418 6.80678 15.3801L1.76318 20.1955V14.7318L3.67131 12.9106V11.0891L1.76318 9.26798V3.8042L6.80678 8.61871C6.00918 9.58101 5.57646 10.7728 5.57913 11.9999Z'
              fill='#546752'
            />
            <path
              d='M35.78 17.5L31.188 12.412V17.5H29.732V6.348H31.188V11.516L35.796 6.348H37.636L32.58 11.932L37.684 17.5H35.78ZM40.1261 10.156C40.3821 9.65467 40.7448 9.26533 41.2141 8.988C41.6941 8.71067 42.2755 8.572 42.9581 8.572V10.076H42.5741C40.9421 10.076 40.1261 10.9613 40.1261 12.732V17.5H38.6701V8.732H40.1261V10.156ZM52.0309 8.732L46.7509 21.628H45.2469L46.9749 17.404L43.4389 8.732H45.0549L47.8069 15.836L50.5269 8.732H52.0309ZM54.3105 10.348C54.5985 9.84667 55.0252 9.43067 55.5905 9.1C56.1665 8.75867 56.8332 8.588 57.5905 8.588C58.3692 8.588 59.0732 8.77467 59.7025 9.148C60.3425 9.52133 60.8438 10.0493 61.2065 10.732C61.5692 11.404 61.7505 12.188 61.7505 13.084C61.7505 13.9693 61.5692 14.7587 61.2065 15.452C60.8438 16.1453 60.3425 16.684 59.7025 17.068C59.0732 17.452 58.3692 17.644 57.5905 17.644C56.8438 17.644 56.1825 17.4787 55.6065 17.148C55.0412 16.8067 54.6092 16.3853 54.3105 15.884V21.66H52.8545V8.732H54.3105V10.348ZM60.2625 13.084C60.2625 12.4227 60.1292 11.8467 59.8625 11.356C59.5958 10.8653 59.2332 10.492 58.7745 10.236C58.3265 9.98 57.8305 9.852 57.2865 9.852C56.7532 9.852 56.2572 9.98533 55.7985 10.252C55.3505 10.508 54.9878 10.8867 54.7105 11.388C54.4438 11.8787 54.3105 12.4493 54.3105 13.1C54.3105 13.7613 54.4438 14.3427 54.7105 14.844C54.9878 15.3347 55.3505 15.7133 55.7985 15.98C56.2572 16.236 56.7532 16.364 57.2865 16.364C57.8305 16.364 58.3265 16.236 58.7745 15.98C59.2332 15.7133 59.5958 15.3347 59.8625 14.844C60.1292 14.3427 60.2625 13.756 60.2625 13.084ZM64.643 9.932V15.1C64.643 15.5267 64.7337 15.8307 64.915 16.012C65.0963 16.1827 65.411 16.268 65.859 16.268H66.931V17.5H65.619C64.8083 17.5 64.2003 17.3133 63.795 16.94C63.3897 16.5667 63.187 15.9533 63.187 15.1V9.932H62.051V8.732H63.187V6.524H64.643V8.732H66.931V9.932H64.643ZM71.8791 17.644C71.0578 17.644 70.3111 17.4573 69.6391 17.084C68.9778 16.7107 68.4551 16.1827 68.0711 15.5C67.6978 14.8067 67.5111 14.0067 67.5111 13.1C67.5111 12.204 67.7031 11.4147 68.0871 10.732C68.4818 10.0387 69.0151 9.51067 69.6871 9.148C70.3591 8.77467 71.1111 8.588 71.9431 8.588C72.7751 8.588 73.5271 8.77467 74.1991 9.148C74.8711 9.51067 75.3991 10.0333 75.7831 10.716C76.1778 11.3987 76.3751 12.1933 76.3751 13.1C76.3751 14.0067 76.1725 14.8067 75.7671 15.5C75.3725 16.1827 74.8338 16.7107 74.1511 17.084C73.4685 17.4573 72.7111 17.644 71.8791 17.644ZM71.8791 16.364C72.4018 16.364 72.8925 16.2413 73.3511 15.996C73.8098 15.7507 74.1778 15.3827 74.4551 14.892C74.7431 14.4013 74.8871 13.804 74.8871 13.1C74.8871 12.396 74.7485 11.7987 74.4711 11.308C74.1938 10.8173 73.8311 10.4547 73.3831 10.22C72.9351 9.97467 72.4498 9.852 71.9271 9.852C71.3938 9.852 70.9031 9.97467 70.4551 10.22C70.0178 10.4547 69.6658 10.8173 69.3991 11.308C69.1325 11.7987 68.9991 12.396 68.9991 13.1C68.9991 13.8147 69.1271 14.4173 69.3831 14.908C69.6498 15.3987 70.0018 15.7667 70.4391 16.012C70.8765 16.2467 71.3565 16.364 71.8791 16.364ZM81.9215 8.572C82.9882 8.572 83.8522 8.89733 84.5135 9.548C85.1748 10.188 85.5055 11.116 85.5055 12.332V17.5H84.0655V12.54C84.0655 11.6653 83.8468 10.9987 83.4095 10.54C82.9722 10.0707 82.3748 9.836 81.6175 9.836C80.8495 9.836 80.2362 10.076 79.7775 10.556C79.3295 11.036 79.1055 11.7347 79.1055 12.652V17.5H77.6495V8.732H79.1055V9.98C79.3935 9.532 79.7828 9.18533 80.2735 8.94C80.7748 8.69467 81.3242 8.572 81.9215 8.572ZM95.0199 8.732V17.5H93.5639V16.204C93.2865 16.652 92.8972 17.004 92.3959 17.26C91.9052 17.5053 91.3612 17.628 90.7639 17.628C90.0812 17.628 89.4679 17.4893 88.9239 17.212C88.3799 16.924 87.9479 16.4973 87.6279 15.932C87.3185 15.3667 87.1639 14.6787 87.1639 13.868V8.732H88.6039V13.676C88.6039 14.54 88.8225 15.2067 89.2599 15.676C89.6972 16.1347 90.2945 16.364 91.0519 16.364C91.8305 16.364 92.4439 16.124 92.8919 15.644C93.3399 15.164 93.5639 14.4653 93.5639 13.548V8.732H95.0199ZM107.382 8.572C108.065 8.572 108.673 8.716 109.206 9.004C109.74 9.28133 110.161 9.70267 110.47 10.268C110.78 10.8333 110.934 11.5213 110.934 12.332V17.5H109.494V12.54C109.494 11.6653 109.276 10.9987 108.838 10.54C108.412 10.0707 107.83 9.836 107.094 9.836C106.337 9.836 105.734 10.0813 105.286 10.572C104.838 11.052 104.614 11.7507 104.614 12.668V17.5H103.174V12.54C103.174 11.6653 102.956 10.9987 102.518 10.54C102.092 10.0707 101.51 9.836 100.774 9.836C100.017 9.836 99.4142 10.0813 98.9662 10.572C98.5182 11.052 98.2942 11.7507 98.2942 12.668V17.5H96.8382V8.732H98.2942V9.996C98.5822 9.53733 98.9662 9.18533 99.4462 8.94C99.9369 8.69467 100.476 8.572 101.062 8.572C101.798 8.572 102.449 8.73733 103.014 9.068C103.58 9.39867 104.001 9.884 104.278 10.524C104.524 9.90533 104.929 9.42533 105.494 9.084C106.06 8.74267 106.689 8.572 107.382 8.572Z'
              fill='#546752'
            />
          </svg>
        </a>
        <ul>
          <li>
            <button onClick={() => setCookiesOpened(true)}>Zarządzaj plikami cookie</button>
          </li>
          <li>
            <Link to='/polityka-prywatnosci/'>Polityka prywatności</Link>
          </li>
          <li>
            <Link to='/regulamin/'>Regulamin</Link>
          </li>
        </ul>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.footer`
  background: var(--secondary-300);
  .localizations{
    max-width: 1200px;
    width: calc(100% - var(--pageMargin) * 2);
    margin: 0 auto;
    height: 100%;

    display: grid;
    grid-template-columns: auto 1fr;
    gap: 24px;  
    padding-bottom: 32px;

    @media (max-width: 864px) {
      grid-template-columns: 1fr;
    }
    
    @media (max-width: 768px) {
      adding-bottom: 24px;
    }

    p{
      font-size: 16px;
      margin-top: 12px;
    }

    ul{
      display: flex;
      flex-wrap: wrap;
      gap: 12px;

      @media (max-width: 549px) {
        gap: 6px;
      }

      li{
        a{
          display: flex;
          align-items: center;
          gap: 8px;
          border-radius: 8px;
          border: 1px solid #C1D6C7;
          background: #F3F5F2;
          padding: 12px;
          font-size: 16px;

          @media (max-width: 549px) {
            font-size: 14px;
            padding: 8px;
          }
        }
      }
    }
  }

  .additional {
    max-width: 1200px;
    width: calc(100% - var(--pageMargin) * 2);
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 48px;
    justify-content: space-between;
    align-items: center;
    padding: 32px 0;
    border-top: 1px solid var(--Colors-Secondary-400, #c1d6c7);
    .kryptonum {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 16px;
    }

    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px 48px;
    }

    @media (max-width: 768px) {
      padding: 24px 0;
      flex-direction: column-reverse;
      justify-content: center;

      ul {
        justify-content: center;
      }

      a,
      button {
        text-align: center;
      }
    }

    @media (max-width: 600px) {
      align-items: flex-start;

      a,
      button {
        text-align: left;
      }

      ul {
        align-items: flex-start;
        flex-direction: column;
      }
    }
  }
  .logo {
    width: fit-content;
  }
  .max-width {
    padding: ${Clamp(32, 48, 64, 'px')} 0 ${Clamp(32, 48, 48, 'px')};
    border-top: 1px solid var(--secondary-400);
    display: grid;
    grid-template-columns: 175px 1fr;
    align-items: flex-start;
    gap: clamp(44px, calc(64vw / 7.68), 150px);

    @media (max-width: 764px) {
      grid-template-columns: 1fr;
    }

    .right-side {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      align-items: flex-start;
      gap: 32px;

      @media (max-width: 1024px) {
        grid-template-columns: 1fr 1fr;
      }
      @media (max-width: 480px) {
        grid-template-columns: 1fr;
      }
    }

    .left-side {
      @media (max-width: 764px) {
        width: fit-content;
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 64px;
      }
      @media (max-width: 550px) {
        grid-template-columns: 1fr;
        gap: 28px;
      }
    }
  }
  ul {
    list-style-type: none;
  }
  .title {
    font-size: ${Clamp(22, 24, 24)};
    font-weight: 700;
    margin-bottom: ${Clamp(24, 24, 32, 'px')};
    display: block;

    @media (max-width: 1024px) {
      margin-bottom: 16px;
    }
  }
  .links {
    ul {
      li:not(:last-child) {
        margin-bottom: 10px;
      }

      a {
        font-size: 16px;
      }
    }
  }
  .socials {
    margin-top: 30px;
    @media (max-width: 764px) {
      margin-top: 0;
    }
    ul {
      width: fit-content;
      display: grid;
      gap: 12px 16px;
      @media (max-width: 764px) {
        grid-template-columns: 1fr 1fr;
      }
      a {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }
  }
  a {
    transition: color 0.4s;
    &:hover {
      color: var(--secondary-900);
    }
  }
  @media (max-width: 1099px) {
  }
  @media (max-width: 499px) {
    .max-width {
      grid-template-columns: 1fr;
      .logo,
      .socials {
        grid-column: unset;
      }
    }
    .socials {
      ul {
        grid-template-columns: auto auto;
      }
    }
  }
`;

export default Footer;
